// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"643":"320d2dab","993":"778b8b4f"}[chunkId] + ".chunk.js";
};